import metricTable from './metricTable'
import {BigNumber} from 'bignumber.js'

export default {
  metricTable: metricTable,
  metricSystems: {
    'si': 'SI Metric units',
    'bi': 'British Imperial units',
    'us': 'US Customary units'
  },
  nativeMetrics: ['units', 'vol', 'mass', 'len'],
  getBaseMetricFromDBint (dbInt) {
    switch (dbInt) {
      case 0:
        return this.metricTable.find(item => {
          return item.sid === 'si-units-units'
        })
      case 1:
        return this.metricTable.find(item => {
          return item.sid === 'si-vol-ml'
        })
      case 2:
        return this.metricTable.find(item => {
          return item.sid === 'si-mass-mg'
        })
      case 3:
        return this.metricTable.find(item => {
          return item.sid === 'si-len-mm'
        })
    }
  },
  convertToBaseUnits (quantity, sid) {
    return new BigNumber(this.getMetricRowFromSid(sid).ratio).times(quantity).toNumber()
  },
  getScalingOptions (sid) {
    // This function returns scaling options based on the metric system
    // and metric defined in the sid e.g. si-vol
    // and delivers the list in order of low -> high
    var searchSid = sid.substr(0, sid.indexOf('-', sid.indexOf('-') + 1))
    return this.metricTable.filter(item => {
      return item.sid.startsWith(searchSid)
    })
  },
  humanizeDBMetric (quantity, metric) {
    // Scales a large quantity into the highest metric
    // so that quantity is above 1
    // e.g. 9000 ml -> 9 L
    var bestMetric = this.getIdealMetric(quantity, metric)

    var convertedQuantity = new BigNumber(quantity).dividedBy(bestMetric.ratio).toNumber()

    return {
      quantity: convertedQuantity,
      sid: bestMetric.sid
    }
  },
  getIdealMetric (quantity, metricInt) {
    var metricDefinition = this.getBaseMetricFromDBint(metricInt)
    var scaleOptions = this.getScalingOptions(metricDefinition.sid)

    var bestMetric = scaleOptions[0]

    Object.values(scaleOptions).forEach(scaleOption => {
      if (Math.abs(quantity) >= scaleOption.ratio) {
        bestMetric = scaleOption
      }
    })
    return bestMetric
  },
  sidToInt (sid) {
    return this.nativeMetrics.indexOf(sid.split('-')[1])
  },
  convertToNative (quantity, sid, definition) {
    var splitSid = sid.split('-')
    var givenMetricInt = this.nativeMetrics.indexOf(splitSid[1])
    var requiredMetricInt = definition.metric
    var ratio = 1
    if (givenMetricInt !== requiredMetricInt) { // Conversion required
      ratio = this.getConversionRatio(givenMetricInt, requiredMetricInt, definition)
    }
    return this.convertToBaseUnits(quantity, sid) * ratio
  },
  getMetricRowFromSid (sid) {
    return this.metricTable.find(item => {
      return item.sid === sid
    })
  },
  getConversionRatioFromSids (sid1, sid2, definition) {
    // this is actually doing what its name says
    if (sid1 === sid2) {
      return 1
    }
    var base1 = this.convertIntToBaseUnits(this.sidToInt(sid1), definition)
    base1 /= this.getMetricRowFromSid(sid1).ratio
    var base2 = this.convertIntToBaseUnits(this.sidToInt(sid2), definition)
    base2 /= this.getMetricRowFromSid(sid2).ratio
    var ratio = new BigNumber(base2).dividedBy(base1)
    if (!isFinite(ratio) || ratio.isEqualTo(0)) {
      return null
    }
    return ratio
  },
  getConversionRatioFromSidsOld (sid1, sid2, definition) {
    // this doesnt do as expected. Change its name FFS
    return this.getConversionRatio(this.sidToInt(sid1), this.sidToInt(sid2), definition)
  },
  getConversionRatio (givenMetricInt, requiredMetricInt, definition) {
    if (givenMetricInt === requiredMetricInt) {
      return 1
    }
    var given = this.convertIntToBaseUnits(givenMetricInt, definition)
    var required = this.convertIntToBaseUnits(requiredMetricInt, definition)
    var ratio = new BigNumber(required).dividedBy(given)
    if (!isFinite(ratio) || ratio.isEqualTo(0)) {
      return null
    }
    return ratio
  },
  getWeightRatio (definition) {
    if (definition.metric === 2) {
      return new BigNumber(1)
    } else {
      var ratio = this.getConversionRatio(definition.metric, 2, definition)
      return ratio
    }
  },
  convertIntToBaseUnits (metricInt, definition) {
    switch (metricInt) {
      case 0:
        return definition.units
      case 1:
        return this.convertToBaseUnits(definition.volume, definition.volume_sid)
      case 2:
        return this.convertToBaseUnits(definition.mass, definition.mass_sid)
      case 3:
        return this.convertToBaseUnits(definition.length, definition.length_sid)
      default:
        return null
    }
  }
}
